import ModelResult from './src/ModelResult.vue'

ModelResult.install = function(Vue) {
    Vue.component(ModelResult.name, ModelResult)
}

export default ModelResult